"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submit = exports.query = void 0;
const constants_1 = require("./constants");
function query({ name, filter }, { http, env, token }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = (yield http.post(constants_1.URL[env].graphql, {
            data: { query: constants_1.GRAPHQL_QUERY[name], variables: filter },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }));
        return response;
    });
}
exports.query = query;
// Will be deprecated soon according to Insights team
function submit(data, { http, env, token }) {
    return __awaiter(this, void 0, void 0, function* () {
        return http.put(constants_1.URL[env].rest, {
            data,
            withCredentials: false,
            headers: {
                "Content-Type": "application/x-protobuf",
                "x-ads-token-data": "{}",
                Authorization: `Bearer ${token}`,
            },
        });
    });
}
exports.submit = submit;
